import React from 'react';
import './Results.css';

const Results = ({ recommendation, answers, onRestart }) => {
  const { 
    strategy, 
    title,
    reasoning, 
    nextSteps, 
    costEstimate, 
    timeline,
    warnings 
  } = recommendation;

  const getStrategyIcon = () => {
    switch(strategy) {
      case 'patent':
        return '📋';
      case 'trade-secret':
        return '🔒';
      case 'hybrid':
        return '🔄';
      case 'defensive-publication':
        return '📢';
      case 'ship-it':
        return '🚀';
      default:
        return '💡';
    }
  };

  const getStrategyColor = () => {
    switch(strategy) {
      case 'patent':
        return '#5A95D8';
      case 'trade-secret':
        return '#7b1fa2';
      case 'hybrid':
        return '#5A95D8';
      case 'defensive-publication':
        return '#00897b';
      case 'ship-it':
        return '#f57c00';
      default:
        return '#546e7a';
    }
  };

  // Create URL with answers for waitlist
  const getWaitlistUrl = () => {
    const baseUrl = 'https://www.patentext.com/patentext-origin';
    const params = new URLSearchParams({
      strategy: strategy,
      innovation: answers['q1'] || '',
      stage: answers['q2'] || '',
      funding: answers['q3'] || ''
    });
    return `${baseUrl}?${params.toString()}`;
  };

  const handleWaitlistClick = () => {
    // Track waitlist click with PostHog
    if (window.posthog) {
      window.posthog.capture('waitlist_clicked', {
        strategy: strategy,
        innovation_type: answers['q1']
      });
    }
  };

  return (
    <div className="results-container">
      <div className="results-header">
        <div className="strategy-icon" style={{ background: `${getStrategyColor()}15` }}>
          <span style={{ fontSize: '48px' }}>{getStrategyIcon()}</span>
        </div>
        <div className="recommendation-label">Your situation leans toward:</div>
        <h1 className="results-title">{title}</h1>
      </div>

      <div className="results-content">
        <section className="results-section">
          <h2>Why this makes sense for you</h2>
          <ul className="reasoning-list">
            {reasoning.map((reason, index) => (
              <li key={index} className="reasoning-item">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" className="check-icon">
                  <circle cx="10" cy="10" r="9" fill={getStrategyColor() + '20'} />
                  <path d="M6 10L9 13L14 7" stroke={getStrategyColor()} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                {reason}
              </li>
            ))}
          </ul>
        </section>

        {warnings && warnings.length > 0 && (
          <section className="results-section warning-section">
            <h2>
              <span className="warning-emoji">⚠️</span>
              Important considerations
            </h2>
            <ul className="warning-list">
              {warnings.map((warning, index) => (
                <li key={index}>{warning}</li>
              ))}
            </ul>
          </section>
        )}

        <div className="results-grid">
          <section className="results-section">
            <h2>Next steps</h2>
            <ol className="steps-list">
              {nextSteps.map((step, index) => (
                <li key={index} className="step-item">
                  <span className="step-number">{index + 1}</span>
                  <span className="step-text">{step}</span>
                </li>
              ))}
            </ol>
          </section>

          <section className="results-section">
            <h2>Timeline & costs</h2>
            <div className="info-box">
              <div className="info-item">
                <span className="info-label">Estimated cost</span>
                <span className="info-value">{costEstimate}</span>
              </div>
              <div className="info-item">
                <span className="info-label">Timeline</span>
                <span className="info-value">{timeline}</span>
              </div>
            </div>
          </section>
        </div>

        <section className="cta-section">
          <h2>Ready to protect your invention?</h2>
          <p>Introducing Patentext Origin: an all-in-one IP platform for founders.</p>
          <div className="cta-buttons">
            <a 
              href={getWaitlistUrl()} 
              className="cta-button primary"
              onClick={handleWaitlistClick}
              target="_blank"
              rel="noopener noreferrer"
            >
              Join the waitlist
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M7 13L13 7M13 7H7M13 7V13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </a>
          </div>
          <button className="restart-button" onClick={onRestart}>
            Start over with new invention
          </button>
        </section>

        <div className="legal-disclaimer">
          This is not legal advice. Consult with an IP attorney for guidance specific to your situation.
        </div>
      </div>
    </div>
  );
};

export default Results;
